import { Col, Row } from "antd";
import dayjs from "dayjs";
import { DocumentBlock } from "@entities/journal";
import { fallbackString, useIsUnifiedMode } from "@shared/utils";
import "./section-second-details.scss";

interface SectionSecondDetailsProps {
  currentItem: any;
  fileId?: string;
  fileName?: string;
}

export const SectionSecondDetails = ({
  currentItem,
  fileId,
  fileName,
}: SectionSecondDetailsProps) => {
  const isUnifiedMode = useIsUnifiedMode();
  const fmtDate = (d?: string) => (d ? dayjs(d).format("DD.MM.YYYY") : "-");

  const groups = (currentItem.journalKeepersList ?? []).map((k: any) => {
    const orgRaw = k?.company?.fullName || "-";
    const org = orgRaw ? `"${String(orgRaw).replace(/^"+|"+$/g, "")}"` : "-";
    return { org, orgId: k?.company?.id };
  });

  return (
    <div className="section-second-details">
      <div className="section-second-details__section">
        <div className="section-second-details__title">
          Информация о журнале
        </div>

        <div className="section-second-details__table">
          <Row className="section-second-details__row">
            <Col span={8} className="section-second-details__label">
              Наименование специального журнала
            </Col>
            <Col span={16} className="section-second-details__text">
              {fallbackString(currentItem?.specialJournalName)}
            </Col>
          </Row>

          <Row className="section-second-details__row">
            <Col span={8} className="section-second-details__label">
              Организация, осуществляющая строительство или организация,
              осуществляющая подготовку проектной документации, ведущая журнал
            </Col>
            <Col span={16} className="section-second-details__text">
              {fallbackString(groups[0]?.org)}
            </Col>
          </Row>

          <Row className="section-second-details__row">
            <Col span={8} className="section-second-details__label">
              Дата создания журнала
            </Col>
            <Col span={16} className="section-second-details__text">
              {fallbackString(fmtDate(currentItem?.specialJournalDate))}
            </Col>
          </Row>

          <Row className="section-second-details__row">
            <Col span={8} className="section-second-details__label">
              Дата передачи журнала застройщику или техническому заказчику
            </Col>
            <Col span={16} className="section-second-details__text">
              {fallbackString(fmtDate(currentItem?.dateHandover))}
            </Col>
          </Row>

          {/* <Row className="section-second-details__row">
            <Col span={8} className="section-second-details__label">
              Дата окончания работ
            </Col>
            <Col span={16} className="section-second-details__text">
              {fallbackString(fmtDate(currentItem?.dateEnd))}
            </Col>
          </Row> */}

          {fileId && fileName && (
            <div className="journal-info-block--spaced-top">
              <DocumentBlock
                title="Цифровая копия журнала (необязательно)"
                fileName={fileName}
                fileId={fileId}
                isInfoHidden
                disableLinkAction={isUnifiedMode}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
